import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { AppShell } from '@/components/layout/app-shell'
import { ForbiddenError, getSessionUser } from '@/features/auth/session'

export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => {
    try {
      const user = await getSessionUser(context.queryClient)
      if (!user) throw redirect({ to: '/login', search: { redirect: location.href } })
      return { user }
    } catch (error) {
      if (error instanceof ForbiddenError)
        throw redirect({ to: '/login', search: { error: 'forbidden' } })
      throw error
    }
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
})
